/* KWD wishlist client-side fix — 2026-08-25
   Server-side Liquid templates (collection.products_by_handle, collection.wishlist)
   can't see the handle list the theme JS passes as ?constraint=, because Shopify
   only fills current_tags from validated tag URL segments. Both endpoints came back
   with no products, so the popup and the full page were always empty.
   This overrides the two render paths on theme.StoreLists.lists.wishlist to fetch
   /products/{handle}.js directly and build the item list in the browser. */
(function () {
  function ready(cb) {
    var t = setInterval(function () {
      if (window.theme && theme.StoreLists && theme.StoreLists.lists && theme.StoreLists.lists.wishlist && window.Shopify && Shopify.formatMoney) {
        clearInterval(t);
        cb();
      }
    }, 60);
    setTimeout(function () { clearInterval(t); }, 15000);
  }

  var cache = {};
  function loadHandle(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[h];
  }

  function loadItems(items) {
    var handles = [];
    for (var i = 0; i < items.length; i++) {
      for (var k in items[i]) if (items[i].hasOwnProperty(k)) handles.push(items[i][k]);
    }
    var uniq = handles.filter(function (h, i) { return handles.indexOf(h) === i; });
    return Promise.all(uniq.map(loadHandle)).then(function (arr) {
      return arr.filter(function (p) { return p; });
    });
  }

  function resize(url, size) {
    if (!url) return '';
    return url.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + size + '$1$2');
  }

  function renderPopup($popup, items, products) {
    var $items = $popup.find('.popup-wishlist__items');
    var tpl = document.getElementById('template-wishlist-ajax');
    if (!tpl) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < items.length; i++) {
      var entry = items[i];
      for (var vid in entry) {
        if (!entry.hasOwnProperty(vid)) continue;
        var handle = entry[vid];
        var product = null;
        for (var p = 0; p < products.length; p++) if (products[p].handle === handle) { product = products[p]; break; }
        if (!product) continue;
        var variant = null;
        for (var v = 0; v < product.variants.length; v++) if (+product.variants[v].id === +vid) { variant = product.variants[v]; break; }
        if (!variant) continue;
        var imgSrc = variant.featured_image ? variant.featured_image.src : product.featured_image;
        var $item = $(tpl.content).children().clone();
        var $wrap = $item.find('.product-store-lists');
        $wrap.attr('data-product-variant-id', vid).attr('data-product-handle', handle);
        $item.find('a').not('.product-store-lists__remove').attr('href', '/products/' + handle + '?variant=' + vid);
        $item.find('.product-store-lists__title a').text(product.title);
        $item.find('.product-store-lists__image img')
          .attr('src', resize(imgSrc, '100x'))
          .attr('srcset', resize(imgSrc, '100x') + ' 1x, ' + resize(imgSrc, '100x@2x') + ' 2x')
          .removeAttr('data-src').removeAttr('data-srcset');
        if (variant.title && variant.title !== 'Default Title') {
          $item.find('.product-store-lists__variant').text(variant.title).removeClass('d-none-important');
        }
        $item.find('.product-store-lists__price .price').html(Shopify.formatMoney(variant.price));
        frag.appendChild($item[0]);
      }
    }
    $items.empty().append(frag);
  }

  function renderFull($popup, items, products) {
    var $content = $popup.find('.popup-wishlist-full__content');
    if (!items.length) {
      $content.html(
        '<div class="wishlist"><div class="page-width">' +
        '<div class="d-flex flex-column align-items-center py-100 my-100"><h3>Wish List</h3>' +
        '<p>No products were added to the Wish List</p></div></div></div>'
      );
      return;
    }
    var html = ['<div class="wishlist"><h2 class="h3 mb-30 text-center">Wish list</h2><div class="page-width"><ul class="cm-grid">'];
    for (var i = 0; i < items.length; i++) {
      var entry = items[i];
      for (var vid in entry) {
        if (!entry.hasOwnProperty(vid)) continue;
        var handle = entry[vid];
        var product = null;
        for (var p = 0; p < products.length; p++) if (products[p].handle === handle) { product = products[p]; break; }
        if (!product) continue;
        var variant = null;
        for (var v = 0; v < product.variants.length; v++) if (+product.variants[v].id === +vid) { variant = product.variants[v]; break; }
        if (!variant) continue;
        var imgSrc = variant.featured_image ? variant.featured_image.src : product.featured_image;
        var href = '/products/' + handle + '?variant=' + vid;
        var img = resize(imgSrc, '400x');
        var title = $('<div>').text(product.title).html();
        var varTitle = (variant.title && variant.title !== 'Default Title') ? '<div class="product-store-lists__variant">' + $('<div>').text(variant.title).html() + '</div>' : '';
        html.push(
          '<li class="cm-grid__item cm-grid__item--wishlist">' +
          '<div class="product-store-lists d-flex flex-column align-items-start mb-20" data-product-variant-id="' + vid + '" data-product-handle="' + handle + '">' +
          '<div class="product-store-lists__image mb-10"><a href="' + href + '"><img src="' + img + '" alt=""></a></div>' +
          '<div class="product-store-lists__title mb-3"><h3 class="p m-0"><a href="' + href + '">' + title + '</a></h3></div>' +
          varTitle +
          '<div class="product-store-lists__price mt-10 mb-10"><span class="price">' + Shopify.formatMoney(variant.price) + '</span></div>' +
          '<span class="product-store-lists__remove btn-link js-store-lists-remove-wishlist">Remove</span>' +
          '</div></li>'
        );
      }
    }
    html.push('</ul></div></div>');
    $content.html(html.join(''));
  }

  ready(function () {
    var list = theme.StoreLists.lists.wishlist;
    var popup = theme.StoreLists.popups.wishlist;

    function currentItems() {
      var raw = localStorage.getItem(list.current_storage);
      try { return (typeof cmSafeList === 'function' ? cmSafeList(raw) : JSON.parse(raw || '[]')) || []; }
      catch (e) { return []; }
    }

    /* mini popup */
    popup.update = function ($popup) {
      var items = currentItems();
      var $content = $popup.find('.popup-wishlist__content');
      var $empty = $popup.find('.popup-wishlist__empty');
      var $items = $popup.find('.popup-wishlist__items');
      var $count = $popup.find('[data-js-popup-wishlist-count]');
      var tmpl = (theme.strings && theme.strings.general && theme.strings.general.popups && theme.strings.general.popups.wishlist && theme.strings.general.popups.wishlist.count) || '{{ count }}';
      $count.html(tmpl.replace('{{ count }}', items.length));
      $content[items.length ? 'removeClass' : 'addClass']('d-none-important');
      $empty[items.length ? 'addClass' : 'removeClass']('d-none-important');
      if (!items.length) { $items.empty(); return; }
      loadItems(items).then(function (products) { renderPopup($popup, items, products); });
    };

    /* full popup ("View Wish List") */
    popup.updateFull = function ($popup) {
      var items = currentItems();
      loadItems(items).then(function (products) { renderFull($popup, items, products); });
    };
  });
})();
